import { NodeLogo } from '../../../shared/components/NodeLogo/NodeLogo';
import { Destination } from '../../../shared/interfaces/destination';
import { Tooltip } from '../../../tooltip/Tooltip';
import { DestinationActions } from '../../DestinationActions/DestinationActions';

export function DestinationHeader({ destination }: { destination: Destination }) {
  return (
    <header className='secondary-nav floating-header center-flex-row py-4 px-5'>
      <div className='integration-heading flex-1'>
        <span className='entity-id-container text-nowrap'>
          <span className='entity-id'>#{destination!.seqId}</span>
        </span>

        <div className='integration-node'>
          <NodeLogo
            logoURL={destination.destinationType.logo}
            darkModeLogoURL={destination.destinationType.logoDarkMode}
            withContextualBg
            size={12}
            roundedBorders
          />

          <div className='node-details'>
            <div className='node-name-container'>
              <Tooltip dataId='pipeline-name' title={destination.name} enableOnTextOverflow>
                <div className='node-name text-ellipsis'>{destination.name}</div>
              </Tooltip>
            </div>

            <div className='d-flex'>
              <Tooltip
                dataId='source-type'
                title={destination.destinationType.displayName}
                enableOnTextOverflow
              >
                <span className='node-type'>{destination.destinationType.displayName}</span>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>

      <div className='center-flex-row'>
        <DestinationActions destination={destination} />
      </div>
    </header>
  );
}
